import { render, staticRenderFns } from "./BasicReporting.vue?vue&type=template&id=101dde34&"
import script from "./BasicReporting.vue?vue&type=script&lang=ts&"
export * from "./BasicReporting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports